<template>
  <ElInput
    v-model="amountInnerShow"
    :style="{ width: width + 'px', }"
    :placeholder="placeholder"
    :disabled="disabled"
    :size="size"
    @input="val=>$emit('watchValue',val)"
    @focus="handleAmountFocus"
    @blur="handleAmountBlur($event)"
  >
    <slot name="prepend" slot="prepend">
      <span v-if="currencySymbol">{{currencySymbol}}</span>
    </slot>
  </ElInput>
</template>

<script>
import { commaNum } from '@/services/utils/index'
import { isNullOrUndefinedOrEmptyStr } from '@/services/utils/modules/base'

// eslint-disable-next-line no-unused-vars
function maxDecimalNum(num, decimal) {
  const v = Math.pow(10, decimal)
  return Math.floor(num * v) / v
}

export default {
  name: 'AmountInput',
  props: {
    currencySymbol: {
      type: [String],
    },
    amount: {
      type: [Number, String, undefined],
      require: true,
      default: undefined
    },
    decimal: {
      type: Number,
      default: 2
    },
    noDecimal: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'mini'
    },
    minValue: {
      type: [Number, String],
      default: undefined
    },
    maxValue: {
      type: [Number, String],
      default: undefined
    },
    width: {
      type: Number,
      default: 120
    },
    placeholder: {
      type: String,
      default: '金额'
    },
    // 是否仅允许输入正数
    positive: {
      type: Boolean,
    },
  },
  emits: ['update:amount', 'change'],
  data() {
    return {
      curValidatedVal: '',
      isFocusAmount: false // 是否focus金额input
    }
  },
  computed: {
    amountInner: {
      get() {
        return this.amount
      },
      set(val) {
        this.$emit('update:amount', val)
        this.$emit('change', val)
      }
    },
    amountInnerShow: {
      get() {
        if (isNullOrUndefinedOrEmptyStr(this.amountInner)) {
          return ''
        }

        if (this.isFocusAmount) {
          return this.amountInner
        }

        // 逗号
        if (this.noDecimal) {
          return this.amountInner
        }
        return commaNum(this.amountInner, this.decimal)
      },
      set(val) {
        // 去掉逗号
        this.amountInner = val.trim().replace(',', '')
      }
    }
  },
  methods: {
    handleAmountFocus() {
      this.isFocusAmount = true
    },
    handleAmountBlur(e) {
      this.isFocusAmount = false
      this.validateNumber()
    },
    validateNumber() {
      if (isNullOrUndefinedOrEmptyStr(this.amountInner)) {
        this.curValidatedVal = ''
        return
      }
      let amountInner = Number(this.amountInner)

      if (Number.isNaN(amountInner)) {
        // 如果无法转换成数字，就直接使用上次合法的值
        this.amountInner = this.curValidatedVal
        return
      }
      if (this.minValue !== 'undefined' && this.minValue === 'undefined' && amountInner < this.minValue) {
        amountInner = this.minValue
      }

      if (this.minValue !== 'undefined' && this.maxValue !== 'undefined') {
        if (amountInner > this.maxValue) {
          amountInner = this.maxValue
        };
        if (amountInner < this.minValue) {
          amountInner = this.minValue
        }
      }
      // 处理小数
      // amountInner = maxDecimalNum(amountInner, this.decimal)
      // 正常更新值

      if (this.positive) {
        amountInner = Math.abs(amountInner)
      }

      this.amountInner = amountInner
      this.curValidatedVal = amountInner
    }
  },
  created() {
    this.validateNumber()
  }
}
</script>
